import {
  MountedModalElement,
  InvokeOpenModal,
  InvokeCloseModal,
} from "./types";
import $ from "jquery";

/**
 * 要素の存在確認をし、存在した場合モーダルを開く関数を実行する
 * @param existsElement 要素の存在確認を行う関数
 * @param getInputValue 要素の値を取得する関数
 * @param invokeOpenModal モーダルを開く処理
 * @param triggerSelector トリガー用セレクタ
 */
export const mountedModalElement: MountedModalElement = (
  existsElement,
  getInputValue,
  invokeOpenModal,
  triggerSelector
) => () => {
  if (!existsElement(triggerSelector) || getInputValue(triggerSelector) !== "1")
    return;
  invokeOpenModal();
};

/**
 * モーダルを開き、イベントリスナを登録する
 * @param existsElement 要素の存在確認を行う関数
 * @param existsChildElement 子要素の存在確認を行う関数
 * @param addEvent 要素にイベントをバインドする関数
 * @param invokeCloseModal モーダルを閉じる処理
 * @param selector モーダル要素
 * @param closeSelector 閉じるボタンセレクタ
 * @param overlaySelector オーバーレイセレクタ
 */
export const invokeOpenModal: InvokeOpenModal = (
  existsElement,
  existsChildElement,
  addEvent,
  invokeCloseModal,
  selector,
  closeSelector,
  overlaySelector
) => () => {
  if (
    !existsElement(selector) ||
    !existsChildElement(selector, closeSelector) ||
    !existsChildElement(selector, overlaySelector)
  )
    return;
  const $modal = $(selector);
  $modal.fadeIn().css("display", "flex");
  const $closeElement = $modal.find(closeSelector);
  const $overlayElement = $modal.find(overlaySelector);
  addEvent($closeElement, "click", invokeCloseModal, {
    modalSelector: selector,
  });
  addEvent($overlayElement, "click", invokeCloseModal, {
    modalSelector: selector,
  });
};

/**
 * モーダルを閉じて、イベントリスナを削除する
 * @param removeEvent 要素からイベントを削除する関数
 */
export const invokeCloseModal: InvokeCloseModal = (removeEvent) => (event) => {
  event.stopPropagation();
  const target = (event as any).currentTarget;
  $((event as any).data.modalSelector).fadeOut();
  removeEvent(target, "click");
};
